import { Dispatch, useCallback, useEffect, useState } from "react";
import styles from "./CartFormCards.module.css";
import { Action } from "../../../Bundles/Types";
import { CartConfigInterface } from "../../CartTypes";
import DragHandle from "../../../../components/Icons/DragHandle";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import useSlideCartMixpanelHook from "../../../../hooks/useSlideCartMixpanelHook";

const CartPositionsCard = ({
    fields,
    dispatchCartConfig,
}: {
    submit: any;
    fields: any;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const { trackCartFeature } = useSlideCartMixpanelHook();
    const { cart_features_positions } = fields;

    const [renderArr, setRenderArr] = useState([cart_features_positions.value]);

    useEffect(() => {
        setRenderArr(cart_features_positions?.value);
    }, [cart_features_positions.value]);

    const moveCard = useCallback(
        (originalIdx: number, newIdx: number) => {
            const temp = [...renderArr];
            const draggedCard = temp[originalIdx];
            temp.splice(originalIdx, 1);
            temp.splice(newIdx, 0, draggedCard);
            dispatchCartConfig({
                payload: temp,
                key: "cart_features_positions",
            });
            trackCartFeature({
                cta: `[${temp
                    ?.map((feat) => feat.key)
                    .join(",")
                    ?.toString()}]`,
                ctaType: "Cart Feature Positions",
                featName: "Cart Design",
            });

            setRenderArr(temp);
            cart_features_positions.onChange(temp);
        },
        [renderArr, cart_features_positions],
    );

    const onDropReferences = (res: any) => {
        if (!res.destination.droppableId || !res.source.droppableId) return;
        else {
            moveCard(res.source.index, res.destination.index);
        }
    };

    return (
        <div className={styles.designCardWrapper} style={{ minHeight: 180 }}>
            <div className={styles.cardLabel}>Customize Cart Feature Placement</div>
            <DragDropContext onDragEnd={onDropReferences}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div className={styles.headingsDiv} {...provided.droppableProps} ref={provided.innerRef}>
                            {cart_features_positions?.value?.length ? (
                                <div className={styles.productsRender}>
                                    {cart_features_positions?.value.map((feature: any, pIdx: number) => (
                                        <Draggable key={feature.key} draggableId={feature.key} index={pIdx}>
                                            {(provided, snapshot) => (
                                                <div
                                                    key={feature.key}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        ...provided.draggableProps.style,
                                                        borderRadius: 10,
                                                        border: snapshot.isDragging
                                                            ? "1px solid black"
                                                            : "1px solid transparent",
                                                        backgroundColor: "white",
                                                        padding: "5px",
                                                    }}
                                                >
                                                    <div>
                                                        <DragHandle />
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                            cursor: "default",
                                                        }}
                                                    >
                                                        <div className={styles.featureName}>{feature.label}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
};

export default CartPositionsCard;
